module.exports = __webpack_public_path__ + "img/speedo-meter.eb4ff16d.gif";